import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CheckmarkAlternativeIcon = function CheckmarkAlternativeIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CheckmarkAlternativeIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.463 8a5.537 5.537 0 1 1 11.074 0A5.537 5.537 0 0 1 2.463 8M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m3.167 5.387a.731.731 0 1 0-1.11-.953L7.021 8.967 5.943 7.713a.731.731 0 1 0-1.11.954l1.633 1.9a.73.73 0 0 0 1.11 0z",
      clipRule: "evenodd"
    })
  }));
};

export { CheckmarkAlternativeIcon };
